import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://afpygawuynetepkpezgw.supabase.co'
const supabaseKey = 'sb_publishable_-cBe8oFBOC2YPeLSZQrhHQ_YyJ0b0yD'

export const supabase = createClient(supabaseUrl, supabaseKey)
